import { ContentService } from 'app/store/services/content.service';
import { ActivatedRoute, Router } from '@angular/router';
import {
  Button,
  ButtonColor,
  ButtonSize,
} from './../../store/models/button.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-group-name',
  templateUrl: './edit-group-name.component.html',
  styleUrls: ['./edit-group-name.component.scss'],
})
export class EditGroupNameComponent implements OnInit {
  contentGroupName: string;

  contentGroupId: number;

  groupEditError: boolean;

  inputForm: FormGroup;

  cancelButtonProperties: Button;

  submitButtonProperties: Button = {
    color: ButtonColor.ORANGE,
    text: 'Update',
    size: ButtonSize.SMALL,
    onClick: () => {
      if (this.inputForm.valid) {
        this.contentService
          .updateContentGroupName(
            this.contentGroupId,
            this.inputForm.get('groupName').value
          )
          .subscribe(
            () => {
              this.router.navigate(['/contents/content_group']);
            },
            () => (this.groupEditError = true)
          );
      }
    },
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private contentService: ContentService,
    private router: Router
  ) {}

  ngOnInit() {
    this.contentGroupId = this.activatedRoute.snapshot.params.id;
    this.contentGroupName = this.activatedRoute.snapshot.params.groupName;
    this.inputForm = new FormGroup({
      groupName: new FormControl(this.contentGroupName, [Validators.required]),
    });

    this.cancelButtonProperties = {
      text: 'Cancel',
      color: ButtonColor.WHITE,
      route: [
        '/contents',
        this.contentGroupId,
        'content',
        {
          group_name: this.contentGroupName,
        },
      ],
      size: ButtonSize.SMALL,
    };
  }

  submitForm() {}
}
